import styled from 'styled-components';

export const SelectWrapper = styled.div`
  background: ${props => props.theme.colors.white};
  width: 190px;
  height: 30px;
  border: 1px solid ${props => props.theme.colors.lightGray};
  border-radius: 2px;
  position: relative;
  margin-right: 10px;
  background: ${props => props.theme.colors.white};
  ${props => props.theme.mediaQueries.phone}{
    margin-left: 10px;
  };
`;

export const ButtonWrapper = styled.div`
  background: ${props => props.theme.colors.dropDownLiveHub};
  width: 20px;
  height: 20px;
  border-radius: 2px;
  right: 4px;
  position: absolute;
  cursor: pointer;
  margin-top: 4px;
  ${props => props.theme.mediaQueries.tablet_big_down}{
    right: 3px;
`;

export const OptionsWrapper = styled.ul`
  list-style: none;
  visibility: ${props => (props.isOpen ? 'visible' : 'hidden')};
  width: 160px;
  align-self: flex-start;
  position: absolute;
  left: -1px;
  padding-top: 5px;
  top: 28px;
  border: 1px solid ${props => props.theme.colors.lightGray};
  border-top: none;
  border-radius: 0 0 2px 2px;
  background: ${props => props.theme.colors.white};
  z-index: 3;
  -webkit-margin-before: 0;
  -webkit-margin-after: 0;
  -webkit-padding-start: 0;
  ${props => props.theme.mediaQueries.tablet_big_down}{
    width: 101.5%;
    max-height: 300px;
    overflow-y: scroll;
  }
  .isActive {
    background-color: ${props => props.theme.colors.selectedColor};
    color: ${props => props.theme.colors.white};
  }
`;

export const Option = styled.li`
  padding: 5px 5px 7px 7px;
  cursor: pointer;
  text-transform: uppercase;
  position: relative;
  text-align: left !important;
  font-family: ${props => props.theme.fontSets.narrowMedium};
  &:hover{
    background: ${props => props.theme.colors.tableHeaderColor};
    color: ${props => props.theme.colors.mainFontColor};
  }
  font-size: 13px;
  display: block !important;
  width: 100% !important;
  height: 15px !important;
  line-height: 1 !important;
  padding-left: 7px !important;
  padding-top: 5px !important;
  padding-bottom: 20px !important;
  
`;

export const OptionLink = styled.a`
`;

export const SelectedOption = styled.div`
  text-transform: uppercase;
  cursor: pointer;
  padding: 8px 0 0 7px;
  position: absolute;
  align-self: flex-start;
  text-align: left;
  left: 0;
  font-family: ${props => props.theme.fontSets.narrowMedium};
  font-size: 13px;
  color: ${props => props.theme.colors.black};
`;




// WEBPACK FOOTER //
// ./src/components/shared/Dropdown/styles.js